import React, { useState, useEffect, useMemo } from 'react';
import swal from 'sweetalert';
import { BOLETA, FACTURA, IGV, IVAP, decimalAdjust, EFECTIVO, YAPE, POS, MASTER, AMERICAN, OTROS, PAGO_CREDITO, PLIN, RAPPI, TUNKI, CREDITO, CONTADO, VALE, convertStrToJson } from '../Global';
import { defaultPostHeaders } from '../helpers/wrappers';
import { calcularTotales } from '../Global';
import calcularVenta from '../helpers/calcularVenta';
import EfectivoImg from './RegistroVentas/images/efectivo.png';
import Mastercard from './RegistroVentas/images/mastercard.png';
import Pos from './RegistroVentas/images/pos-icon.png';
import American from './RegistroVentas/images/american.png';
import OtrosPagos from './RegistroVentas/images/otros.png';
import Credito from './RegistroVentas/images/credito.png';
import Yape from './RegistroVentas/images/yape.png';
import Plin from './RegistroVentas/images/plin logo.png';
import Rappi from './RegistroVentas/images/rappi logo.png';
import Tunki from './RegistroVentas/images/tunki logo.png';
import { notificarError, notificarMsg } from '../componentes/Almacenes/AlmacenNotify';
import printTicket from './RegistroVentas/Ticket';
import printA4 from '../helpers/A4';
import downprintA4 from '../helpers/DA4';
import Modal from '../componentes/clientes/ClienteModal';
import { CuotasCreditoModal } from '../componentes/Preventas/CuotasCreditoModal';
import moment from 'moment';

const GrifosPagos = ({ IdPreventa, onCompleted, isBlocked }) => {
    const [pagos, setPagos] = useState([]);
    const [totalPagado, setTotalPagado] = useState(0);
    const [showModalValidacion, setShowModalValidacion] = useState(false);
    const [modalValidacionTipoPago, setModalValidacionTipoPago] = useState(null);
    const [disableCredit, setDisableCredit] = useState(false);
    const [disableAll, setDisableAll] = useState(false);
    const [shouldRemovePayments, setShouldRemovePayments] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [totales, setTotales] = useState({});
    const [detalles, setDetalles] = useState([]);
    const [preventa, setPreventa] = useState(null);
    const [paymentDone, setPaymentDone] = useState(false);
    const [venta, setVenta] = useState(null);
    const [detallesVenta, setDetallesVenta] = useState([]);
    const [cuentasBancarias, setCuentasBancarias] = useState([]);
    const [extImg] = useState('png');
    
    // Estados para pagos a crédito
    const [showModalCuotasCredito, setShowModalCuotasCredito] = useState(false);
    const [creditoSelected, setCreditoSelected] = useState(false);
    const [infoCuotasCredito, setInfoCuotasCredito] = useState({});

    // Estados para WhatsApp
    const [showModalWhatsApp, setShowModalWhatsApp] = useState(false);
    const [isSendingWhatsApp, setIsSendingWhatsApp] = useState(false);
    const [whatsAppNumber, setWhatsAppNumber] = useState("");
    const [whatsAppPlaceholder, setWhatsAppPlaceholder] = useState("Ingrese 9 dígitos");
    const whatsAppInputRef = React.useRef(null);

    // Calcular vuelto de forma memoizada (como en PagosUI.js)
    const vuelto = useMemo(() => {
        if (!totales.totalMonto || typeof totales.totalMonto !== 'number') return 0;
        if (totalPagado <= totales.totalMonto) return 0;
        
        const vueltoCalculado = totalPagado - totales.totalMonto;
        return decimalAdjust('round', vueltoCalculado, -2);
    }, [totalPagado, totales.totalMonto]);

    // Efecto 1: Cargar preventa, detalles y cuentas bancarias cuando se recibe IdPreventa
    useEffect(() => {
        if (IdPreventa) {
            getPreventa(IdPreventa);
            fetchCuentasBancarias();
        }
    }, [IdPreventa]);

    // Efecto para hacer focus en el input de WhatsApp
    useEffect(() => {
        if (showModalWhatsApp && whatsAppInputRef.current) {
            setTimeout(() => {
                whatsAppInputRef.current.focus();
            }, 100);
        }
    }, [showModalWhatsApp]);

    const getPreventa = async (IdPreventa) => {
        try {
            setIsLoading(true);
            const response = await fetch(`/api/gestionPreventas/preventa/${IdPreventa}`);
            if (!response.ok) {
                throw new Error();
            }

            const data = await response.json();
            const [{IdCliente, IdTipoDocumentoSunat, Observaciones, GuiaRemision, OrdenCompra, Alias}] = data.respuesta;
            setPreventa({ IdCliente, IdTipoDocumentoSunat, Observaciones, GuiaRemision, OrdenCompra, Alias });

            await getDetallePreventa(IdPreventa);
        } catch (e) {
            console.error(e);
            notificarError("No se pudo cargar la preventa");
        } finally {
            setIsLoading(false);
        }
    };

    const getDetallePreventa = async (IdPreventa) => {
        try {
            const response = await fetch(`/api/gestionPreventas/detallepreventa/${IdPreventa}`);
            if (!response.ok) {
                throw new Error();
            }

            const { respuesta: detalles } = await response.json();
            setDetalles(detalles);

            const totales = calcularTotales(detalles);
            setTotales({
                Gravado: totales.gravados,
                Inafecto: totales.inafectos,
                Exonerado: totales.exonerados,
                IGVPreventa: totales.gravados * IGV,
                Gratuitas: totales.gratuitos,
                totalMonto: totales.total,
                ICBPERPreventa: totales.icbper,
                redondeo: totales.redondeo,
            });
        } catch (e) {
            console.error(e);
            notificarError("No se pudo cargar el detalle de la preventa");
        }
    };

    const fetchCuentasBancarias = async () => {
        try {
            const response = await fetch('/api/cuentas/numeroscuenta');
            if (!response.ok) {
                throw new Error();
            }
            const cuentas = await response.json();
            setCuentasBancarias(cuentas);
        } catch (e) {
            console.error(e);
        }
    };

    const openModalWhatsApp = () => {
        const rawPhone = (venta && venta.Celular) || preventa?.Celular || "";
        let cleanNumber = String(rawPhone).replace(/\D/g, "");

        if (cleanNumber.startsWith("51") && cleanNumber.length > 9) {
            cleanNumber = cleanNumber.substring(2);
        }

        if (cleanNumber.length > 9) {
            cleanNumber = cleanNumber.slice(-9);
        }

        setWhatsAppPlaceholder(cleanNumber.length === 9 ? cleanNumber : "Ingrese 9 dígitos");
        setWhatsAppNumber("");
        setShowModalWhatsApp(true);
    };

    const handleCloseModalWhatsApp = () => {
        setShowModalWhatsApp(false);
        setWhatsAppNumber("");
        setWhatsAppPlaceholder("Ingrese 9 dígitos");
    };

    const sendWhatsApp = async () => {
        const numeroDestino = (whatsAppNumber || whatsAppPlaceholder || "").trim();

        if (!numeroDestino || numeroDestino.length !== 9) {
            notificarMsg("Por favor, ingrese un número de WhatsApp válido (9 dígitos).", "warning");
            return;
        }

        setIsSendingWhatsApp(true);
        try {
            const configReq = await fetch("/api/config/whatsapp");
            if (!configReq.ok) {
                throw new Error("No se pudo obtener la configuración de WhatsApp");
            }
            const waConfig = await configReq.json();
            const { Url, ApiKey, Instancia } = waConfig;
            const rv = venta;
            const resEnvioSunat = convertStrToJson(rv.respuestaEnvioSunat);

            const codigoTipo = String(rv.CodigoTipoComprobante || '').padStart(2, '0');
            const numeroSinCeros = ((rv.NumeroComprobante || '').toString().replace(/^0+/, '') || '0');

            const oldXmlUrl = `${process.env.REACT_APP_FACT_BASE_URL}/datos/${rv.Ruc}/xml/${codigoTipo}/${rv.Ruc}-${codigoTipo}-${rv.Serie}-${numeroSinCeros}.xml`;
            const oldCdrUrl = `${process.env.REACT_APP_FACT_BASE_URL}/datos/${rv.Ruc}/xml/${codigoTipo}/R-${rv.Ruc}-${codigoTipo}-${rv.Serie}-${numeroSinCeros}.zip`;

            const xmlUrl = oldXmlUrl.replace('http//', 'https//');
            const cdrUrl = oldCdrUrl.replace('http//', 'https//');

            const response = await fetch(`${Url}/message/sendText/${Instancia}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "apikey": ApiKey
                },
                body: JSON.stringify({
                    number: `51${numeroDestino}`,
                    text: `*${rv.Empresa || ''}*\n*RUC: ${rv.Ruc || ''}*\n_______________________________\n\n*📄 COMPROBANTE ELECTRÓNICO*\n*🧾 ${rv.Serie || ''}-${((rv.NumeroComprobante || '').toString().replace(/^0+/, '') || '0')}*\n*💰 TOTAL: ${rv.Simbolo || 'S/'}. ${decimalAdjust('floor', rv.Total, -2).toFixed(2)}*\n\nEstimado cliente, puede gestionar sus archivos en los siguientes enlaces:\n\n*📁 Descarga Directa:*\n🔹 *XML:* ${xmlUrl}\n🔹 *CDR:* ${cdrUrl}\n\n*📑 ¿Necesitas el PDF?*\nConviértelo aquí: https://mifacturaperu.com/convertidor.php\n\n🌐 _WWW.MIFACTURAPERU.COM_`,
                    delay: 1200,
                    linkPreview: true
                })
            });

            if (response.ok) {
                swal({
                    title: "¡Enviado!",
                    text: "El mensaje ha sido enviado correctamente por WhatsApp.",
                    icon: "success"
                });
                handleCloseModalWhatsApp();
            } else {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || "Error al enviar el mensaje");
            }
        } catch (error) {
            console.error("WhatsApp API Error:", error);
            swal({
                title: "Error",
                text: "No se pudo enviar el mensaje. Verifique la configuración o intente más tarde.",
                icon: "error"
            });
        } finally {
            setIsSendingWhatsApp(false);
        }
    };

    // Efecto 2: Validar habilitación de método crédito y deshabilitación total de pagos
    useEffect(() => {
        const clienteVarios = detalles?.[0]?._client?.NroTipoDocumento === "99999999";
        const hasCreditPayment = pagos.some(p => p.IdTipoPago === PAGO_CREDITO);

        setDisableCredit(clienteVarios || hasCreditPayment);
        setCreditoSelected(hasCreditPayment);

        if (pagos.length === 0) {
            setDisableAll(false);
            return;
        }

        const lastPaymentIsContado = pagos[pagos.length - 1].IdTipoPago === EFECTIVO;
        setDisableAll(lastPaymentIsContado);
    }, [pagos.length]);

    // Efecto 3: Validar deshabilitación basada en monto pagado
    useEffect(() => {
        const lastPaymentIsContado = pagos.length > 0 && pagos[pagos.length - 1].IdTipoPago === EFECTIVO;
        if (lastPaymentIsContado) {
            setDisableAll(true);
            return;
        }

        const isCompleted = totales.totalMonto - totalPagado <= 0;
        setDisableAll(isCompleted);
    }, [totalPagado, totales.totalMonto]);

    // Efecto 4: Validar que el orden de pagos sea correcto
    useEffect(() => {
        if (!Array.isArray(pagos) || pagos.length === 0) {
            setShouldRemovePayments(false);
            return;
        }

        let fromLeft = false;
        let fromRight = false;
        let restante = totales.totalMonto;

        for (let i = 0; i < pagos.length; i++) {
            const pago = pagos[i];
            restante = restante - pago.Monto;

            if (restante < 0 && pagos.length - 1 !== i) {
                fromLeft = true;
                break;
            }
        }

        restante = totales.totalMonto;

        for (let i = pagos.length - 1; i >= 0; i--) {
            const pago = pagos[i];
            restante = restante - pago.Monto;

            if (restante < 0 && i > 0) {
                fromRight = true;
                break;
            }
        }

        setShouldRemovePayments(fromLeft || fromRight);
    }, [totalPagado, totales.totalMonto]);

    const checkPerm = async (perm, tipoPago) => {
        try {
            const req = await fetch(`/api/usuarios/${perm}/validar`);

            if (!req.ok) {
                throw new Error();
            }

            const data = await req.json();
            setModalValidacionTipoPago(tipoPago);
            setShowModalValidacion(data.codigoConfirmacion);
        } catch (e) {
            handleTipoPago(tipoPago)();
            setShowModalValidacion(false);
        }
    };

    const handleTipoPago = (IdTipoPago) => {
        if (IdTipoPago === PAGO_CREDITO) {
            return () => setShowModalCuotasCredito(true);
        }
        return () => addDetallePago(IdTipoPago);
    };

    const addDetallePago = (IdTipoPago) => {
        const remaining = totales.totalMonto - totalPagado;

        const newPago = {
            IdTipoPago,
            Monto: decimalAdjust('floor', remaining.toFixed(2), -2),
            Referencia: '',
            FechaPago: new Date().toISOString().split('T')[0]
        };

        const newPagos = [...pagos, newPago];
        setPagos(newPagos);

        const newTotalPagado = newPagos.reduce((total, pago) => total + pago.Monto, 0);
        setTotalPagado(newTotalPagado);
        // El vuelto se calcula automáticamente vía useMemo
    };

    const updateMontoPago = async (index, monto) => {
        const newPagos = [...pagos];
        newPagos[index].Monto = parseFloat(monto) || 0;
        setPagos(newPagos);

        const totalPagado = newPagos.reduce((total, pago) => total + pago.Monto, 0);
        setTotalPagado(totalPagado);
        // El vuelto se calcula automáticamente vía useMemo
    };

    const updateReferenciaPago = (index, referencia) => {
        const newPagos = [...pagos];
        newPagos[index].Referencia = referencia;
        setPagos(newPagos);
    };

    const updateFechaPago = (index, fecha) => {
        const newPagos = [...pagos];
        newPagos[index].FechaPago = fecha;
        newPagos[index].PlazoCredito = Number(fecha);
        setPagos(newPagos);
    };

    const removePago = (index) => {
        const newPagos = [...pagos];
        newPagos.splice(index, 1);
        setPagos(newPagos);

        const totalPagado = newPagos.reduce((total, pago) => total + pago.Monto, 0);
        setTotalPagado(totalPagado);
        // El vuelto se calcula automáticamente vía useMemo
        
        // Actualizar creditoSelected
        const hasCreditPayment = newPagos.some(p => p.IdTipoPago === PAGO_CREDITO);
        setCreditoSelected(hasCreditPayment);
    };

    // Función para manejar cuotas de crédito
    const onAceptarCuotasCredito = (data) => {
        const IdTipoPago = PAGO_CREDITO;
        const total = totales.totalMonto;
        const montoPagar = decimalAdjust('round', total / data.cantCuotas, -2);
        const pagos = [];
        let initialDate = moment(new Date()).add(data.cantDias, 'days');

        for (let i = 1; i <= data.cantCuotas; i++) {
            pagos.push({
                IdTipoPago,
                Monto: montoPagar,
                Referencia: null,
                FechaPago: initialDate,
                PlazoCredito: IdTipoPago === PAGO_CREDITO && 1,
                descuento: data.descuento
            });
            initialDate = moment(initialDate).add(data.cantDias, 'days');
        }

        setInfoCuotasCredito(data);
        setShowModalCuotasCredito(false);
        setCreditoSelected(true);
        setPagos([...pagos]);
        
        const newTotalPagado = pagos.reduce((total, pago) => total + pago.Monto, 0);
        setTotalPagado(newTotalPagado);
        // El vuelto se calcula automáticamente vía useMemo
    };

    const handlePagar = async () => {
        if (shouldRemovePayments) {
            alert("El orden de los medios de pago seleccionados no son válidos. Verifique si todos son necesarios e inténtelo otra vez.");
            return;
        }

        if (totalPagado < decimalAdjust('floor', totales.totalMonto, -2)) {
            notificarError("El monto pagado es menor al total");
            return;
        }

        setIsLoading(true);
        try {
            const ventaCalculada = await calcularVenta({
                Descuento: 0,
                TasaIGV: IGV,
                TasaICBPER: 0.3,
                TasaIVAP: IVAP,
                Items: detalles.map(detalle => ({
                    ValorUnitario: detalle.ValorUnitario,
                    Cantidad: detalle.Cantidad,
                    Descuento: detalle.Descuento,
                    Tributos: JSON.parse(detalle.Tributos),
                    TasaISC: detalle.TasaIsc,
                    IdStock: detalle.IdStock,
                    PrecioReferencial: detalle.PrecioReferencial,
                    IdAfectacionIgv: detalle.IdAfectacionIgv,
                    IdPresentacion: detalle.IdPresentacion,
                    TipoCambio: detalle.TipoCambio,
                    Gratuito: detalle.Gratuito,
                    PrecioVenta: detalle.PrecioVenta,
                }))
            });

            const {IdRegistroVenta} = await registrarVenta(ventaCalculada);

            const venta = await getVenta(IdRegistroVenta);
            const detallesVentaList = await getDetalleVenta(IdRegistroVenta, ventaCalculada);
            
            // Guardar venta y detalles para reimpresión
            setVenta(venta);
            setDetallesVenta(detallesVentaList);
            
            await printTicket(detallesVentaList, venta, 'png');
        } catch (e) {
            console.error(e);
            notificarError("No se pudo registrar la venta");
        } finally {
            setIsLoading(false);
        }
    };

    const getVenta = async (IdRegistroVenta) => {
        const url = preventa.IdTipoDocumentoSunat == VALE ? `/api/vales/get/${IdRegistroVenta}` : `/api/ventas/get/${IdRegistroVenta}`;

        const response = await fetch(url);
        if (!response.ok) {
            throw new Error();
        }
        const data = await response.json();
        return data.respuesta[0];
    }

    const getDetalleVenta = async (IdRegistroVenta) => {
        const url = preventa.IdTipoDocumentoSunat == VALE ? `/api/vales/detalles/${IdRegistroVenta}` : `/api/ventas/detalles/${IdRegistroVenta}`;

        const response = await fetch(url);
        
        if (!response.ok) {
            throw new Error();
        }

        const data = await response.json();
        return data.respuesta;
    }

    const registrarVenta = async (ventaCalculada) => {
        const totales = calcularTotales(detalles);
        const pagosInfo = pagos?.map(p => p.extra_metadata).filter(e => !!e);

        const response = await fetch("/api/ventas/new", {
            method: "POST",
            headers: defaultPostHeaders(),
            body: JSON.stringify({
                IdCliente: preventa?.IdCliente,
                IdTipoOperacion: IdPreventa,
                TipoTabla: "Preventas",
                Estado: "GENERADO",
                IdModalidadPago: pagos.some(({IdTipoPago}) => IdTipoPago === PAGO_CREDITO) ? CREDITO : CONTADO,
                IdTipoComprobante: preventa?.IdTipoDocumentoSunat || BOLETA,
                IdMoneda: 1,
                TipoCambio: 1,
                TasaIGV: IGV,
                TasaICBPER: 0.3,
                DescuentoTotal: 0,
                Gravadas: totales.gravados,
                Exoneradas: totales.exonerados,
                Inafectas: totales.inafectos,
                ICBPER: totales.icbper,
                Exportacion: 0.0,
                Total: totales.total,
                Vuelto: vuelto || 0,
                Observacion: "",
                IGV: totales.gravados * IGV,
                ISC: ventaCalculada.ISC,
                Gratuitas: totales.gratuitos,
                PorcentajeDescuento: ventaCalculada.PorcentajeDescuento,
                IVAP: ventaCalculada.IVAP,
                TasaIVAP: ventaCalculada.TasaIVAP,
                TasaISC: ventaCalculada.ISC,
                descuento: ventaCalculada.Descuento,
                Redondeo: totales.redondeo,
                pagosInfo: JSON.stringify(pagosInfo),
                guiaRemision: null,
                ordenCompra: ""
            })
        });

        if (!response.ok) {
            throw new Error();
        }

        const [[table_data], [header]] = await response.json();
        let error = false;
        if (header._estado) {
            error = header._estado;
        } else if (header._estadoRegistroVentas !== true) {
            error = header._estadoRegistroVentas;
        }

        if (error) {
            throw new Error(error);
        }

        const [{IdRegistroVenta}] = table_data;

        const urlRegistroPagos = preventa.IdTipoDocumentoSunat == VALE ? "/api/pagos/vale/new" : "/api/pagos/new";

        // Registrar pagos
        await fetch(urlRegistroPagos, {
            method: "POST",
            headers: defaultPostHeaders(),
            body: JSON.stringify({
                DetallesPagos: pagos.map(pago => [
                    IdRegistroVenta,
                    pago.IdTipoPago,
                    pago.Monto,
                    pago.IdTipoPago === PAGO_CREDITO ? "PENDIENTE" : "PAGADO",
                    pago.Referencia,
                    pago.FechaPago && moment(pago.FechaPago).format("YYYY-MM-DD"),
                    true,
                    pago.descuento || 0
                ])
            })
        });

        const urlRegistroDetalles = preventa.IdTipoDocumentoSunat == VALE ? "/api/ventas/detalles/vales/new" : "/api/ventas/detalles/new";

        // Registrar detalles de venta
        await fetch(urlRegistroDetalles, {
            method: "POST",
            headers: defaultPostHeaders(),
            body: JSON.stringify({
                Items: ventaCalculada.Items.map(detalle => [
                    IdRegistroVenta,
                    detalle.IdStock,
                    detalle.Cantidad,
                    detalle.PrecioReferencial,
                    detalle.PrecioVenta,
                    detalle.IdAfectacionIgv,
                    detalle.IdPresentacion,
                    detalle.Total,
                    detalle.Descuento,
                    detalle.TipoCambio,
                    detalle.ISC,
                    detalle.IGV,
                    detalle.ICBPER,
                    detalle.IVAP,
                    detalle.TasaISC,
                    detalle.ValorUnitario,
                    detalle.DescuentoSI,
                    detalle.Gratuito
                ])
            })
        });

        // Enviar a SUNAT
        await fetch(`/api/configFactElectronica/ce/${IdRegistroVenta}`);

        setPaymentDone(true);

        await onCompleted();
        return {IdRegistroVenta};
    };

    const reload = () => {
        window.location.reload();
    }

    return (
       <div className="card abed__content-grifos" style={{ 
            position: 'relative',
            opacity: isBlocked ? 0.5 : 1,
            pointerEvents: isBlocked ? 'none' : 'auto'
        }}>
            {isBlocked && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 100,
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    cursor: 'not-allowed'
                }} />
            )}
            
            <div className="card-body pb-2">
                <div className="pagos__container">
                    <div className="row pagos">
                        <div className="col-12">
                            <div className="pagos__methods--container w-100">
                                <div id="carousel-menu-method-pagos"
                                     className="carousel carousel-dark slide w-100 botones-desk" data-interval="false">
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <div className="pagos__methods--container">
                                                <div className="pagos__methods">
                                                    <input
                                                        type="image"
                                                        src={Pos}
                                                        className="btn btn-outline-primary"
                                                        onClick={handleTipoPago(POS)}
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        disabled={disableAll || creditoSelected}
                                                        title="POS"
                                                        tabIndex="1"
                                                    />
                                                </div>
                                                <div className="pagos__methods ml-2">
                                                    <input
                                                        type="image"
                                                        src={EfectivoImg}
                                                        className="btn btn-outline-success"
                                                        onClick={handleTipoPago(EFECTIVO)}
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Efectivo"
                                                        tabIndex="1"
                                                        disabled={disableAll || creditoSelected}
                                                        autoFocus
                                                    />
                                                </div>
                                                <div className="pagos__methods ml-2">
                                                    <input
                                                        type="image"
                                                        src={Yape}
                                                        className="btn btn-yape"
                                                        onClick={handleTipoPago(YAPE)}
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Yape"
                                                        disabled={disableAll || creditoSelected}
                                                        tabIndex="1"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <div className="pagos__methods--container">
                                                <div className="pagos__methods">
                                                    <input
                                                        type="image"
                                                        src={OtrosPagos}
                                                        className="btn btn-outline-warning"
                                                        onClick={() => checkPerm('pago-otros', OTROS)}
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Otros métodos de pago"
                                                        disabled={disableAll || creditoSelected}
                                                        tabIndex="1"
                                                    />
                                                </div>
                                                <div className="pagos__methods ml-2">
                                                    <input
                                                        type="image"
                                                        src={Credito}
                                                        className="btn btn-outline-danger"
                                                        onClick={() => checkPerm('vender-a-credito', PAGO_CREDITO)}
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Crédito"
                                                        disabled={disableAll || disableCredit}
                                                        tabIndex="1"
                                                    />
                                                </div>
                                                <div className="pagos__methods ml-2">
                                                    <input
                                                        type="image"
                                                        src={Plin}
                                                        className="btn btn-yape"
                                                        onClick={handleTipoPago(PLIN)}
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Plin"
                                                        disabled={disableAll || creditoSelected}
                                                        tabIndex="1"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <div className="pagos__methods--container">
                                                <div className="pagos__methods">
                                                    <input
                                                        type="image"
                                                        src={Rappi}
                                                        className="btn btn-fpay"
                                                        onClick={handleTipoPago(RAPPI)}
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Rappi"
                                                        disabled={disableAll || creditoSelected}
                                                        tabIndex="1"
                                                    />
                                                </div>
                                                <div className="pagos__methods ml-2">
                                                    <input
                                                        type="image"
                                                        src={Tunki}
                                                        className="btn btn-yape"
                                                        onClick={handleTipoPago(TUNKI)}
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Tunki"
                                                        disabled={disableAll || creditoSelected}
                                                        tabIndex="1"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <a className="carousel-control-prev btn-atras" href="#carousel-menu-method-pagos"
                                       role="button"
                                       data-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Previous</span>
                                    </a>
                                    <a className="carousel-control-next" href="#carousel-menu-method-pagos" role="button"
                                       data-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Next</span>
                                    </a>
                                </div>
                            </div>
                            <div className="detalles__pago">
                                <div className="detalles__pago__item">
                                    {pagos.map((pago, index) => (
                                        <div key={`pay_${index}`} className="detalle__pago">
                                            <div className="items__detalle__pago botones-desk">
                                                {pago.IdTipoPago === EFECTIVO && (
                                                    <input
                                                        type="image"
                                                        src={EfectivoImg}
                                                        className="btn btn-outline-success item__detalle__pago--img"
                                                        alt="Tipo pago Efectivo"
                                                    />
                                                )}
                                                {pago.IdTipoPago === MASTER && (
                                                    <input
                                                        type="image"
                                                        src={Mastercard}
                                                        className="btn btn-outline-danger item__detalle__pago--img"
                                                        alt="Tipo pago Master Card"
                                                    />
                                                )}
                                                {pago.IdTipoPago === POS && (
                                                    <input
                                                        type="image"
                                                        src={Pos}
                                                        className="btn btn-outline-primary item__detalle__pago--img"
                                                        alt="Tipo pago POS"
                                                    />
                                                )}
                                                {pago.IdTipoPago === AMERICAN && (
                                                    <input
                                                        type="image"
                                                        src={American}
                                                        className="btn btn-outline-info item__detalle__pago--img"
                                                        alt="Tipo pago American"
                                                    />
                                                )}
                                                {pago.IdTipoPago === OTROS && (
                                                    <input
                                                        type="image"
                                                        src={OtrosPagos}
                                                        className="btn btn-outline-warning item__detalle__pago--img"
                                                        alt="Tipo pago Otros"
                                                    />
                                                )}
                                                {pago.IdTipoPago === PAGO_CREDITO && (
                                                    <input
                                                        type="image"
                                                        src={Credito}
                                                        className="btn btn-outline-danger item__detalle__pago--img"
                                                        alt="Tipo pago Crédito"
                                                    />
                                                )}
                                                {pago.IdTipoPago === PLIN && (
                                                    <input
                                                        type="image"
                                                        src={Plin}
                                                        className="btn btn-outline-info item__detalle__pago--img"
                                                        alt="Tipo pago Plin"
                                                    />
                                                )}
                                                {pago.IdTipoPago === RAPPI && (
                                                    <input
                                                        type="image"
                                                        src={Rappi}
                                                        className="btn btn-outline-warning item__detalle__pago--img"
                                                        alt="Tipo pago Rappi"
                                                    />
                                                )}
                                                {pago.IdTipoPago === TUNKI && (
                                                    <input
                                                        type="image"
                                                        src={Tunki}
                                                        className="btn btn-outline-danger item__detalle__pago--img"
                                                        alt="Tipo pago Tunki"
                                                    />
                                                )}
                                                {pago.IdTipoPago === YAPE && (
                                                    <input
                                                        type="image"
                                                        src={Yape}
                                                        className="btn btn-outline-danger item__detalle__pago--img"
                                                        alt="Tipo pago Yape"
                                                    />
                                                )}
                                                <input
                                                    className="item__detalle__pago"
                                                    type="number"
                                                    autoFocus
                                                    placeholder="Monto"
                                                    value={pago.Monto}
                                                    onChange={(e) => updateMontoPago(index, e.target.value)}
                                                    style={{width: "25%"}}
                                                />
                                                {pago.IdTipoPago !== PAGO_CREDITO ? (
                                                    <input
                                                        type="text"
                                                        className="item__detalle__pago"
                                                        placeholder="Ref."
                                                        value={pago.Referencia}
                                                        onChange={(e) => updateReferenciaPago(index, e.target.value)}
                                                        style={{width: "25%"}}
                                                    />
                                                ) : (
                                                    <input
                                                        type="date"
                                                        className="item__detalle__pago"
                                                        value={moment(pago.FechaPago).format("YYYY-MM-DD")}
                                                        onChange={(e) => updateFechaPago(index, e.target.value)}
                                                        style={{width: "25%"}}
                                                    />
                                                )}
                                                <button 
                                                    className="abed__delete-payment-button"
                                                    onClick={() => removePago(index)}
                                                    
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="info__input__container">
                                <div className="input__container">
                                    <label>Vuelto</label>
                                    <input
                                        className="input"
                                        value={typeof vuelto === 'number' ? vuelto.toFixed(2) : (0).toFixed(2)}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="abed__print-options-container">
                                <div className="abed__new-sale-button-container">
                                    {
                                        paymentDone && (
                                            <button 
                                                onClick={reload}
                                                className="abed__new-sale-button"
                                            >
                                                NUEVA VENTA
                                            </button>
                                        )
                                    }

                                </div> 

                                <div className="abed__action-pago-container">
                                    {!paymentDone ? (
                                        <button
                                            className="pagos__boton"
                                            onClick={handlePagar}
                                            disabled={isLoading || paymentDone}
                                        >
                                            {isLoading ? (
                                                <span className="p-0 m-0">
                                                    Procesando
                                                    <span className="dots-animation p-0 m-0 ml-2">
                                                        <span className="p-0 m-0">.</span>
                                                        <span className="p-0 m-0">.</span>
                                                        <span className="p-0 m-0">.</span>
                                                    </span>
                                                </span>
                                            ) : (
                                                <span className="p-0 m-0">PAGAR</span>
                                            )}
                                        </button>
                                    ) : (
                                        <div className="abed__reimpresion-botones-container">
                                            <button
                                                className="abed__reimpresion-boton ticket"
                                                onClick={() => printTicket(detallesVenta, venta, extImg)}
                                            >
                                                <i className="fas fa-print"/> Ticket
                                            </button>
                                            <button
                                                onClick={() => printA4(detallesVenta, venta, extImg, cuentasBancarias)}
                                                className="abed__reimpresion-boton a4"
                                            >
                                                <i className="fas fa-print"/> A4
                                            </button>
                                            <button
                                                onClick={() => downprintA4(detallesVenta, venta, extImg)}
                                                className="abed__reimpresion-boton a4-mobile"
                                            >
                                                <i className="fas fa-print"/> A4 Móvil
                                            </button>
                                            <button
                                                type="button"
                                                onClick={openModalWhatsApp}
                                                className="abed__reimpresion-boton whatsapp"
                                            >
                                                <i className="fab fa-whatsapp"/> Enviar
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Modal de cuotas de crédito */}
            <Modal
                isOpen={showModalCuotasCredito}
                onClose={() => setShowModalCuotasCredito(false)}
                title={"Forma de pago crédito"}
            >
                <div className={showModalCuotasCredito ? "container" : null}
                     style={showModalCuotasCredito ? {width: "200px"} : null}>
                    <CuotasCreditoModal
                        onAceptarCuotasCredito={onAceptarCuotasCredito}
                    />
                </div>
            </Modal>

            {/* Modal de envío por WhatsApp */}
            <Modal 
                isOpen={showModalWhatsApp} 
                onClose={handleCloseModalWhatsApp}
                width="400px"
                title="Enviar por WhatsApp"
            >
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        if (!isSendingWhatsApp) {
                            sendWhatsApp();
                        }
                    }}
                >
                    <div className="form-group">
                        <label className="font-weight-bold">
                            Número de WhatsApp
                        </label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">+51</span>
                            </div>
                            <input
                                ref={whatsAppInputRef}
                                type="text"
                                className="form-control"
                                placeholder={whatsAppPlaceholder}
                                maxLength="9"
                                value={whatsAppNumber}
                                onChange={e => setWhatsAppNumber(e.target.value.replace(/\D/g, ""))}
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <button
                            type="submit"
                            className="btn btn-verde-mfp-letra-normal"
                            title="Enviar"
                            disabled={isSendingWhatsApp}
                        >
                            {isSendingWhatsApp ? (
                                <>
                                    <i className="fas fa-spinner fa-spin mr-2" /> Enviando...
                                </>
                            ) : (
                                "Enviar"
                            )}
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default GrifosPagos; 